var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 179,
    viewBox: "0 0 35 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2076)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.363281 33.1506V151.228C0.363281 159.782 4.08408 164.092 4.08408 164.092H31.0175C31.0175 164.092 34.7383 159.782 34.7383 151.228V33.1506C34.7383 3.61939 17.5508 0 17.5508 0C17.5508 0 0.363281 3.61939 0.363281 33.1506Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52182 23.4111C3.0474 26.0952 2.76953 38.7088 2.76953 42.1791H32.3326C32.3326 38.7088 32.0547 26.0952 31.5803 23.4111H3.52182Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63574 12.1188H27.4597C23.1492 5.27994 17.5443 4.10059 17.5443 4.10059C17.5443 4.10059 11.9394 5.27994 7.63574 12.1188Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3326 42.1787H2.76953V153.458H32.3326V42.1787Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6247 62.1602H4.4707V133.484H30.6247V62.1602Z",
    fill: "#D2D0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9704 133.816H4.13184V61.8145H30.9636V133.816H30.9704ZM4.81635 133.138H30.2926V62.4922H4.80958V133.138H4.81635Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08398 164.086C4.08398 164.086 12.5896 177.994 17.5507 178.841C22.5117 179.689 31.0174 164.086 31.0174 164.086H4.08398Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76953 153.458C2.76953 153.458 8.88953 171.48 17.5511 171.48C25.2027 171.48 31.1465 158.582 32.3326 153.458H2.76953Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63873 90.4707H28.4688L28.4688 64.1454H6.63873L6.63873 90.4707Z",
    fill: "#F2F0D7",
    stroke: "#9D9D9C",
    strokeWidth: 0.11,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61462 76.5625H25.4873V66.1042H9.61462L9.61462 76.5625Z",
    fill: "#FCFAEB",
    stroke: "#B2B2B2",
    strokeWidth: 0.11,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5504 155.986C18.9466 155.986 20.0784 154.854 20.0784 153.458C20.0784 152.062 18.9466 150.93 17.5504 150.93C16.1543 150.93 15.0225 152.062 15.0225 153.458C15.0225 154.854 16.1543 155.986 17.5504 155.986Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5504 144.904C18.9466 144.904 20.0784 143.772 20.0784 142.376C20.0784 140.98 18.9466 139.848 17.5504 139.848C16.1543 139.848 15.0225 140.98 15.0225 142.376C15.0225 143.772 16.1543 144.904 17.5504 144.904Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5504 73.8649C18.9466 73.8649 20.0784 72.733 20.0784 71.3367C20.0784 69.9405 18.9466 68.8086 17.5504 68.8086C16.1543 68.8086 15.0225 69.9405 15.0225 71.3367C15.0225 72.733 16.1543 73.8649 17.5504 73.8649Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.551 9.8961C18.5391 9.8961 19.3402 9.09498 19.3402 8.10674C19.3402 7.11851 18.5391 6.31738 17.551 6.31738C16.5628 6.31738 15.7617 7.11851 15.7617 8.10674C15.7617 9.09498 16.5628 9.8961 17.551 9.8961Z",
    fill: "#C6C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97371 78.7588H25.1348V77.6743H9.97371V78.7588Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.11,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97371 81.5039H25.1348V80.4194H9.97371V81.5039Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.11,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97371 83.957H25.1348V82.8726H9.97371V83.957Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.11,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10019 135.781H5.3584V138.16H7.10019V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6832 44.585H3.94141V46.964H5.6832V44.585Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6832 48.5977H3.94141V50.9767H5.6832V48.5977Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6832 52.7793H3.94141V55.1583H5.6832V52.7793Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4986 44.5039H29.7568V46.8829H31.4986V44.5039Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4986 48.5156H29.7568V50.8947H31.4986V48.5156Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4986 52.6982H29.7568V55.0773H31.4986V52.6982Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9332 135.781H8.19141V138.16H9.9332V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7594 135.781H11.0176V138.16H12.7594V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5924 135.781H13.8506V138.16H15.5924V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4254 135.781H16.6836V138.16H18.4254V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2516 135.781H19.5098V138.16H21.2516V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0846 135.781H22.3428V138.16H24.0846V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9107 135.781H25.1689V138.16H26.9107V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7437 135.781H28.002V138.16H29.7437V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13184 40.837C4.50615 40.837 4.80958 40.5336 4.80958 40.1592C4.80958 39.7849 4.50615 39.4814 4.13184 39.4814C3.75754 39.4814 3.4541 39.7849 3.4541 40.1592C3.4541 40.5336 3.75754 40.837 4.13184 40.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13184 36.1671C4.50615 36.1671 4.80958 35.8636 4.80958 35.4893C4.80958 35.115 4.50615 34.8115 4.13184 34.8115C3.75754 34.8115 3.4541 35.115 3.4541 35.4893C3.4541 35.8636 3.75754 36.1671 4.13184 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61915 29.7755C4.99345 29.7755 5.29689 29.472 5.29689 29.0977C5.29689 28.7234 4.99345 28.4199 4.61915 28.4199C4.24484 28.4199 3.94141 28.7234 3.94141 29.0977C3.94141 29.472 4.24484 29.7755 4.61915 29.7755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0518 40.837C31.4261 40.837 31.7295 40.5336 31.7295 40.1592C31.7295 39.7849 31.4261 39.4814 31.0518 39.4814C30.6775 39.4814 30.374 39.7849 30.374 40.1592C30.374 40.5336 30.6775 40.837 31.0518 40.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0518 36.1671C31.4261 36.1671 31.7295 35.8636 31.7295 35.4893C31.7295 35.115 31.4261 34.8115 31.0518 34.8115C30.6775 34.8115 30.374 35.115 30.374 35.4893C30.374 35.8636 30.6775 36.1671 31.0518 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5635 29.7755C30.9378 29.7755 31.2412 29.472 31.2412 29.0977C31.2412 28.7234 30.9378 28.4199 30.5635 28.4199C30.1892 28.4199 29.8857 28.7234 29.8857 29.0977C29.8857 29.472 30.1892 29.7755 30.5635 29.7755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13184 141.61C4.50615 141.61 4.80958 141.307 4.80958 140.933C4.80958 140.558 4.50615 140.255 4.13184 140.255C3.75754 140.255 3.4541 140.558 3.4541 140.933C3.4541 141.307 3.75754 141.61 4.13184 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13184 146.28C4.50615 146.28 4.80958 145.977 4.80958 145.603C4.80958 145.228 4.50615 144.925 4.13184 144.925C3.75754 144.925 3.4541 145.228 3.4541 145.603C3.4541 145.977 3.75754 146.28 4.13184 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61915 152.672C4.99345 152.672 5.29689 152.369 5.29689 151.994C5.29689 151.62 4.99345 151.316 4.61915 151.316C4.24484 151.316 3.94141 151.62 3.94141 151.994C3.94141 152.369 4.24484 152.672 4.61915 152.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0518 141.61C31.4261 141.61 31.7295 141.307 31.7295 140.933C31.7295 140.558 31.4261 140.255 31.0518 140.255C30.6775 140.255 30.374 140.558 30.374 140.933C30.374 141.307 30.6775 141.61 31.0518 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0518 146.28C31.4261 146.28 31.7295 145.977 31.7295 145.603C31.7295 145.228 31.4261 144.925 31.0518 144.925C30.6775 144.925 30.374 145.228 30.374 145.603C30.374 145.977 30.6775 146.28 31.0518 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5635 152.672C30.9378 152.672 31.2412 152.369 31.2412 151.994C31.2412 151.62 30.9378 151.316 30.5635 151.316C30.1892 151.316 29.8857 151.62 29.8857 151.994C29.8857 152.369 30.1892 152.672 30.5635 152.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5509 109.144C22.5404 109.144 26.5852 105.099 26.5852 100.109C26.5852 95.1193 22.5404 91.0742 17.5509 91.0742C12.5614 91.0742 8.5166 95.1193 8.5166 100.109C8.5166 105.099 12.5614 109.144 17.5509 109.144Z",
    fill: "#191514",
    stroke: "#FFED00",
    strokeWidth: 0.125,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5509 131.511C22.5404 131.511 26.5852 127.466 26.5852 122.476C26.5852 117.486 22.5404 113.441 17.5509 113.441C12.5614 113.441 8.5166 117.486 8.5166 122.476C8.5166 127.466 12.5614 131.511 17.5509 131.511Z",
    fill: "#191514",
    stroke: "#FFED00",
    strokeWidth: 0.125,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3774,
    height: 178.875,
    fill: "white",
    transform: "translate(0.363281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.375,
    height: 178.875,
    fill: "white",
    transform: "translate(0.363281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip1);
export default __webpack_public_path__ + "static/media/ship-1.svg";
export { ForwardRef as ReactComponent };